/**
 * S7 · Content you own (#own) — THE FEED homepage, design.md Part III.
 *
 *  - M2 "magazine pick-up": the scroll driver writes `--p` on `.mag-scene`
 *    while the section passes (≥600px; below that the CSS pins it at rest).
 *    The first time `--p` crosses .5 the post is "saved" (`.is-saved` → the
 *    bookmark pops full + a "Saved" toast). Once only.
 *  - The Boost pill launches the rocket on hover / focus / tap (`.is-launch`,
 *    reset after 900ms).
 * Static-first: without `js-motion` the CSS shows the saved, resting state.
 */
import { registerScene, reduced } from "./runtime";

export function init(): void {
  const section = document.getElementById("own");
  if (!section) return;
  const scene = section.querySelector<HTMLElement>(".mag-scene");
  if (scene) {
    const save = (): void => {
      scene.classList.add("is-saved");
    };
    if (reduced()) save();
    registerScene(scene, "pass", {
      minWidth: 600,
      onProgress: (p) => {
        if (p >= 0.5) save();
      },
    });
    // below 600 there is no scroll-linked moment: save once it is in view
    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting || window.innerWidth >= 600) continue;
            window.setTimeout(save, 700);
            io.disconnect();
          }
        },
        { threshold: 0.6 },
      );
      io.observe(scene);
    } else save();
  }

  const rocket = section.querySelector<HTMLElement>(".own__rocket");
  const boost = section.querySelector<HTMLElement>(".own__boost");
  if (rocket && boost) {
    const launch = (): void => {
      if (reduced() || rocket.classList.contains("is-launch")) return;
      rocket.classList.add("is-launch");
      window.setTimeout(() => rocket.classList.remove("is-launch"), 900);
    };
    boost.addEventListener("pointerenter", launch);
    boost.addEventListener("focus", launch);
    boost.addEventListener("pointerdown", launch);
  }
}
